import { render, staticRenderFns } from "./ProcessDocumentSentMailCardTab.vue?vue&type=template&id=5f632118&scoped=true"
import script from "./ProcessDocumentSentMailCardTab.vue?vue&type=script&lang=js"
export * from "./ProcessDocumentSentMailCardTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f632118",
  null
  
)

export default component.exports